import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import { Box, Stack, Typography } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import { CardComponent } from 'utils/components/card/CardComponent';
import { DocumentItem } from './DocumentItem';

export const REQUIRED_DOCUMENTS = [
  {
    id: 1,
    name: 'Acta constitutiva',
    isUploaded: false,
    nameFromResponse: 'articles_of_incorporation',
  },
  {
    id: 2,
    name: 'Identificación oficial del representante legal',
    isUploaded: false,
    nameFromResponse: 'representative_id',
  },
  {
    id: 3,
    name: 'Constancia de situación fiscal',
    isUploaded: false,
    nameFromResponse: 'tax_id_certificate',
  },
  {
    id: 4,
    name: 'Comprobante de domicilio',
    isUploaded: false,
    nameFromResponse: 'proof_of_address',
  },
  {
    id: 5,
    name: 'Poder del representante legal (opcional)',
    isUploaded: false,
    nameFromResponse: 'legal_representative_appointment',
  },
  {
    id: 6,
    name: 'Otros documentos (opcional)',
    isUploaded: false,
    nameFromResponse: 'other',
  },
];

const DOCUMENTS_SCROLL_HEIGHT = 610;

export const ElectronicDocuments = ({
  createUrl,
  removeDocument,
  isLoadingDocument,
  selectedFilesByDocument,
  activeTypeDocumentId,
  activeDocumentAction,
  pendingFileName,
  documentId,
  uploadedDocuments,
  isTermsAccepted,
  setIsTermsAccepted,
}) => {
  return (
    <>
      <CardComponent title='Documentos electrónicos' minWidth='100%'>
        <Box sx={{ width: '100%', height: DOCUMENTS_SCROLL_HEIGHT, overflowY: 'auto', pr: 0.5 }}>
          <Stack spacing={2.5} sx={{ width: '100%' }}>
            {REQUIRED_DOCUMENTS.map((document) => {
              const responseDocument =
                document.nameFromResponse && uploadedDocuments
                  ? uploadedDocuments?.[document.nameFromResponse]
                  : null;

              const uploadedFileFromApi = responseDocument?.url
                ? {
                    fileName: responseDocument?.file_name || 'Documento cargado',
                    url: responseDocument?.url,
                    documentId:
                      responseDocument?.document_id ||
                      responseDocument?.id ||
                      responseDocument?.documentId ||
                      null,
                  }
                : null;

              const selectedFile = selectedFilesByDocument?.[document.id] || uploadedFileFromApi;

              return (
                <DocumentItem
                  key={document.id}
                  document={document}
                  createUrl={createUrl}
                  removeDocument={removeDocument}
                  isLoadingDocument={isLoadingDocument}
                  selectedFile={selectedFile}
                  activeTypeDocumentId={activeTypeDocumentId}
                  activeDocumentAction={activeDocumentAction}
                  pendingFileName={pendingFileName}
                  documentId={documentId}
                  //uploadedDocuments={uploadedDocuments}
                />
              );
            })}
          </Stack>
        </Box>
        <Box display='flex' alignItems='center' mt={1} sx={{ opacity: 0.6 }}>
          <InfoOutlineIcon sx={{ fontSize: 22 }} />
          <Typography
            sx={{
              fontSize: '14px',
              lineHeight: 1.3,
              color: '#212121',
              fontWeight: 600,
              ml: 1,
            }}
          >
            Los documentos son obligatorios
          </Typography>
        </Box>
      </CardComponent>
      <Box display='flex' alignItems='flex-start' mt={2}>
        <Checkbox
          color='primary'
          sx={{ mt: 2 }}
          size='small'
          checked={isTermsAccepted}
          onChange={(e) => setIsTermsAccepted(e.target.checked)}
        />{' '}
        <Typography variant='body2' sx={{ fontSize: '14px', mt: 3 }}>
          Se validó la constancia de situación fiscal se mostró el Aviso de Privacidad, así como los
          Términos y Condiciones.
        </Typography>
      </Box>
    </>
  );
};
